module.exports = __webpack_public_path__ + "img/vuejs.f64397c9.svg";